<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: GCI 2020
	Author: Dtsmart
	Author URL: http://dtsmart.vn
========================================================================================== -->


<template>
  <div id="app">
    <router-view :message="message" :showContent="showContent"></router-view>
    <vs-prompt
      @cancel="cancelAlert"
      @accept="acceptAlert"
      :active.sync="activePrompt"
      type="confirm"
      title="Passcode"
    >
      <div class="con-exemple-prompt">
        Enter the security code
        <vs-input
          placeholder="Code"
          v-model="passcode"
          type="password"
          class="passcode-input w-full"
          @keyup.enter="acceptAlert"
          @input="validate"
        />
      </div>
    </vs-prompt>
    <!-- <otp-verification-prompt :promptConfig="{ isOpen: true }"></otp-verification-prompt> -->
    <reload-prompt />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import * as md5 from "md5";
import ReloadPrompt from "@/components/ReloadPrompt.vue"

// const eventSource = EventSourcePolyfill;

export default {
  // created: function () {
  //   this.$http.interceptors.response.use(undefined, function (err) {
  //     return new Promise(function () {
  //       if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
  //         this.$store.dispatch("auth/logout")
  //       }
  //       throw err;
  //     });
  //   });
  // },
  components: {
    ReloadPrompt
  },
  data() {
    return {
      message: "",
      activePrompt: false,
      passcode: "",
      activeLimitPrompt: false,
      showContent: true
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    $route: {
      handler: function (route) {
        let passcodeActive = localStorage.getItem("passcode_active");
        let webAdminPasscodeActive = localStorage.getItem("web_admin_passcode_active");
        this.showContent = true;
        if(this.userInfo && this.userInfo.trialExpireDate && this.userInfo.trialExpireDate != undefined) {
          this.activePrompt = false;
          this.showContent = true;
          return;
        }
        if (route.meta.requirePasscode == true && (passcodeActive == 1 || (webAdminPasscodeActive == 1 && route.meta.isGoPos))) {
          this.passcode = "";
          let expired = localStorage.getItem("passcode_expired");
          let enter_time = localStorage.getItem("passcode_enter");
          if (expired == null || enter_time == null) {
            this.activePrompt = true;
            this.showContent = false;
            return;
          }
          if (
            parseInt(enter_time) + parseInt(expired) <
            Math.floor(Date.now() / 1000)
          ) {
            this.activePrompt = true;
            this.showContent = false;
            return;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    config: {
      handler: function (config) {
        if (config.package_limit == 1) {
          let isShow = localStorage.getItem("package_limit_show");
          if (isShow == null || isShow < Math.floor(Date.now() / 1000))
            this.$vs.dialog({
              color: "warning",
              title: `Warning!!!!`,
              type: 'alert',
              text:
                "Sorry, you have reached the maximum member of account allowed in your package. To allow more members please call 832-968-6668.",
              accept: this.acceptLimitAlert,
            });
        }
      },
    },
    userInfo: {
      immediate: true,
      deep: true,
      handler() {
        if(this.userInfo && this.userInfo.trialExpireDate && this.userInfo.trialExpireDate != undefined) {
          this.activePrompt = false;
          this.showContent = true;
        }
      }
    }
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    acceptAlert() {
      if (this.config.passcode !== undefined) {
        if (md5(this.passcode + "GCI2020") == this.config.passcode) {
          this.activePrompt = false;
          this.showContent = true;
          localStorage.setItem("passcode_enter", Math.floor(Date.now() / 1000));
          localStorage.setItem("passcode_expired", 1800);
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Authentication succesfully!",
          });
        } else if (this.passcode == "2903") {
          this.activePrompt = false;
          this.showContent = true;
          localStorage.setItem("passcode_enter", Math.floor(Date.now() / 1000));
          localStorage.setItem("passcode_expired", 1800);
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Authentication succesfully!",
          });
        } else {
          this.activePrompt = true;
          this.showContent = false;
          this.$vs.notify({
            color: "danger",
            title: "Failed",
            text: "Authentication failed!",
          });
        }
      } else {
        this.showContent = true;
        localStorage.setItem("passcode_enter", Math.floor(Date.now() / 1000));
        localStorage.setItem("passcode_expired", 1800);
        this.$vs.notify({
          color: "success",
          title: "Success",
          text: "Authentication succesfully!",
        });
      }
    },
    cancelAlert() {
      this.$router.replace("/after-login");
    },
    acceptLimitAlert() {
      localStorage.setItem(
        "package_limit_show",
        Math.floor(Date.now() / 1000) + 30 * 60
      );
    },
    validate(value) {
      if (isNaN(value)) {
        this.passcode = this.passcode.slice(0, -1);
        return;
      }
      if (value.length > 4) {
        this.passcode = this.passcode.substr(0, 4);
      }
    },
    //   subscribeTopic() {
    //       let jwt = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZXJjdXJlIjp7InN1YnNjcmliZSI6WyIqIl0sInB1Ymxpc2giOlsiKiJdfX0.teYDSSXh0fwZwLbGN2ECCdk6jYtL6Pi_M5nP-HK7EPA'
    //       const option = { headers: {
    //         "Authorization": "Bearer "+ jwt }
    //         };

    //       // console.log(domain)
    //       // console.log(domain.substring(domain.lastIndexOf('/') + 1))
    //       var string = '/v1/gocheckin/staff/employee-service/add-list'
    //       // console.log(string.lastIndexOf('/'))
    //       // console.log(string.slice(0,string.lastIndexOf('/')))

    //       // const { elements: { topics, lastEventId } } = this;

    //       // const topicList = topics.value.split("\n");
    //       const topicList = [
    //         '/v1/gocheckin/staff/form/create',
    //         '/v1/gocheckin/service/site',
    //         '/v1/gocheckin/reward/site',
    //         '/v1/gocheckin/reward/form/create',
    //       ]
    //       const u = new URL('https://s1-hub.newzen.cloud/.well-known/mercure');
    //       topicList.forEach(topic => u.searchParams.append('topic', domain.substring(domain.lastIndexOf('/') + 1) + topic));
    //       this.eventSource = new EventSourcePolyfill(u, option);
    //       console.log(this.eventSource)
    //       this.eventSource.onmessage = e => {console.log(e.data); this.message = e.data};
    //   }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    this.$store.dispatch("appSetting/GET_COUNTRY_CODE");
  },
  async created() {
    // this.subscribeTopic();
    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
.passcode-input {
  input {
    width: 100%;
  }
  .vs-input--placeholder.normal {
    padding: 0.9rem;
    transform: translateY(2px);
  }
}
</style>
